import { PlayersTable } from '../components/PlayersTable'
import { Player } from '../assets/data'
import { Dispatch, SetStateAction } from 'react'
interface HomeProps {
  players: Player[]
  setDetails: Dispatch<SetStateAction<null | Player>>
}
function Home({ players, setDetails }: HomeProps) {

  return (
    <div>
      <h3>Rock Stats and History</h3>
      <p>The complete source for current and historical rock players, scores and leaders.</p>
      <PlayersTable players={players} setDetails={setDetails} />
    </div>
  )
}

export default Home
